import { home } from '@/constants/routes';

type RouterLike = {
    back: () => void;
    replace: (href: string) => void;
};

export const canGoBack = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const navigation = (window as Window & { navigation?: { canGoBack?: boolean } }).navigation;
    if (typeof navigation?.canGoBack === 'boolean') {
        return navigation.canGoBack;
    }

    return window.history.length > 1;
};

export const goBackOrHome = (router: RouterLike) => {
    if (canGoBack()) {
        router.back();
        return;
    }

    router.replace(home);
};
